import { IStepSubOrdersTableReport } from "../../../Interfaces/stepInterfaces";
import { getSubOrders } from "../../../Requests/stepRequests";
import { CommonTableUI } from "../../TableTemplate/common";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { SubOrdersTableAdditional } from "./SubOrdersTableAdditional";
import { memo } from "react";

interface ISubOrdersTableProps {
  stepOrderId: number;
}

const SubOrdersTable = memo(({ stepOrderId }: ISubOrdersTableProps) => {
  return (
    <TableTemplate<ISubOrdersTableProps, IStepSubOrdersTableReport>
      getDataTable={getSubOrders}
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={SubOrdersTableAdditional}
        />
      )}
      initialSearchParameters={{ stepOrderId }}
    />
  );
});

export default SubOrdersTable;
